import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

const NAV = [
  { to: "/dashboard", label: "Dashboard", icon: "▣" },
  { to: "/rpis-manager", label: "RPIS Manager", icon: "▤" },
  { to: "/registry", label: "Patients", icon: "❑" },
  { to: "/live-agent", label: "Live RPIS Agent", icon: "●" },
  { to: "/clinic-prep", label: "Clinic Prep", icon: "□" },
  { to: "/knowledge", label: "Knowledge Library", icon: "❖" },
  { to: "/style", label: "Style Library", icon: "✑" },
  { to: "/tasks", label: "Clinical Action Center", icon: "✓" },
  { to: "/reports", label: "Reports", icon: "▤" },
  { to: "/appointments", label: "Appointments", icon: "◷" },
  { to: "/analytics", label: "Clinic Stats", icon: "▰" },
];

export function NavShell() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="flex h-screen w-full">
      <aside className="hidden md:flex md:flex-col w-60 shrink-0 border-r border-line bg-bg-alt/60 backdrop-blur-sm">
        <div className="px-4 py-5 border-b border-line">
          <Link to="/dashboard" className="block">
            <div className="text-sm tracking-widest text-accent">RPIS</div>
            <div className="text-xs text-slate-400">
              Radiation Oncology Command Center
            </div>
          </Link>
        </div>
        <nav className="flex-1 px-2 py-3 space-y-1 text-sm">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              className={({ isActive }) =>
                `flex items-center gap-2 rounded-lg px-3 py-2 transition ${
                  isActive
                    ? "bg-accent/15 text-accent border border-accent/30"
                    : "text-slate-300 hover:bg-panel2 hover:text-slate-100"
                }`
              }
            >
              <span className="w-4 text-center opacity-80">{n.icon}</span>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 text-xs text-slate-500 border-t border-line">
          v0.3.0 · AI-V4 bridge
          <div className="mt-1 text-amber-300/80">
            Patient File is the normal review surface.
          </div>
        </div>
      </aside>

      <main className="flex-1 flex flex-col min-w-0">
        <header className="flex items-center justify-between gap-3 px-5 py-3 border-b border-line bg-bg-alt/60 backdrop-blur-sm">
          <div className="text-sm text-slate-300">
            Logged in as{" "}
            <span className="text-slate-100 font-semibold">
              {user?.full_name || user?.username}
            </span>{" "}
            <span className="badge-info ml-2">{user?.role}</span>
          </div>
          <button
            className="btn-ghost"
            onClick={() => {
              logout();
              navigate("/login");
            }}
          >
            Log out
          </button>
        </header>
        <div className="flex-1 overflow-y-auto p-5">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
